import styled from "../../../config/emotion";

export const LoaderContainer = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoaderImg = styled.img<{ size?: number }>`
  ${({ size }) => {
    if (size === undefined) return "";
    return `
      height: ${size}px;
      width: ${size}px;
    `;
  }}
`;
